(() => {
  if (window.raStockUpsellLoaded) return;
  window.raStockUpsellLoaded = true;
  const root = window.Shopify?.routes?.root || '/';
  let adding = false;
  let refreshVersion = 0;
  const announce = (message) => {
    let status = document.getElementById('ra-upsell-status');
    if (!status) {
      status = document.createElement('div'); status.id = 'ra-upsell-status';
      status.className = 'visually-hidden'; status.setAttribute('role', 'status');
      document.body.append(status);
    }
    status.textContent = message;
  };
  let popup;
  let checkoutStarted = false;
  const seenKey = 'ra-stock-upsell-popup-v1';
  const closePopup = () => { if (popup?.open) popup.close(); };
  document.addEventListener('click', event => {
    if (event.target.closest('[name="checkout"], #checkout, #CartDrawer-Checkout, a[href*="/checkout"]')) {
      checkoutStarted = true; closePopup();
    }
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest('.ra-stock-upsell__variant');
    if (!select) return;
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    const button = form.querySelector('button');
    button.textContent = `Add — ${option.dataset.price}`;
    button.setAttribute('aria-label', `Add ${form.closest('article').querySelector('.ra-stock-upsell__title').textContent} — ${option.textContent}`);
    const img = form.closest('article').querySelector('img');
    if (img && option.dataset.image) { img.removeAttribute('srcset'); img.src = option.dataset.image; }
  });
  function schedulePopup() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    try { if (sessionStorage.getItem(seenKey)) return; } catch (_) { return; }
    setTimeout(() => {
      if (checkoutStarted || document.visibilityState !== 'visible' || document.querySelector('dialog[open], cart-drawer.active')) return;
      const source = document.querySelector('.ra-stock-upsell-slot[data-placement="page"]');
      if (!source?.querySelector('[data-ra-upsell-form]')) return;
      popup = document.createElement('dialog');
      popup.className = 'ra-upsell-dialog';
      popup.setAttribute('aria-label', 'Add something extra to your order');
      popup.innerHTML = '<div class="ra-upsell-dialog__top"><button type="button" class="ra-upsell-dialog__close" aria-label="Close accessory recommendations" autofocus>×</button></div><div class="ra-stock-upsell-slot" data-placement="popup"></div><div class="ra-upsell-dialog__footer"><button type="button" class="ra-upsell-dialog__dismiss">No thanks</button><button type="button" class="ra-stock-upsell__add" data-ra-popup-checkout>Continue to checkout</button></div>';
      popup.querySelector('.ra-stock-upsell-slot').innerHTML = source.innerHTML;
      document.body.append(popup);
      const previousFocus = document.activeElement;
      popup.querySelector('.ra-upsell-dialog__close').onclick = closePopup;
      popup.querySelector('.ra-upsell-dialog__dismiss').onclick = closePopup;
      popup.querySelector('[data-ra-popup-checkout]').onclick = () => {
        checkoutStarted = true; closePopup();
        const checkout = document.querySelector('#checkout, button[name="checkout"]');
        if (checkout) checkout.click(); else location.assign(`${root}checkout`);
      };
      popup.addEventListener('click', event => { if (event.target === popup) { const r = popup.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closePopup(); } });
      popup.addEventListener('close', () => { document.documentElement.classList.remove('ra-upsell-modal-open'); if (!checkoutStarted) previousFocus?.focus({preventScroll:true}); });
      popup.showModal();
      document.documentElement.classList.add('ra-upsell-modal-open');
      sessionStorage.setItem(seenKey, '1');
    }, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedulePopup, {once:true}); else schedulePopup();
  async function refreshOffers() {
    const version = ++refreshVersion;
    try {
      const response = await fetch(`${root}cart?section_id=ra-stock-upsell`);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = html.querySelector('.ra-stock-upsell-slot');
      if (source && version === refreshVersion) document.querySelectorAll('.ra-stock-upsell-slot').forEach(slot => { slot.innerHTML = source.innerHTML; });
      if (popup?.open && !popup.querySelector('[data-ra-upsell-form]')) closePopup();
    } catch (_) { /* Cart and checkout remain usable when recommendations cannot refresh. */ }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshOffers());
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ra-upsell-form]');
    if (!form) return;
    event.preventDefault();
    if (adding) return;
    adding = true;
    const button = form.querySelector('button');
    const error = form.querySelector('[role="alert"]');
    const label = button.textContent;
    const inDrawer = Boolean(form.closest('cart-drawer'));
    const inPopup = Boolean(form.closest('.ra-upsell-dialog'));
    const variantId = Number(form.elements.id.value);
    const select = form.querySelector('select');
    if (select) select.disabled = true;
    const title = form.closest('article').querySelector('.ra-stock-upsell__title').textContent;
    error.textContent = ''; button.disabled = true; button.textContent = 'Adding…';
    const drawer = document.querySelector('cart-drawer');
    const footer = document.getElementById('main-cart-footer');
    const items = document.getElementById('main-cart-items');
    const sectionIds = ['cart-icon-bubble'];
    if (drawer) sectionIds.push('cart-drawer');
    if (footer?.dataset.id) sectionIds.push(footer.dataset.id);
    if (items?.dataset.id) sectionIds.push(items.dataset.id);
    let added = false;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: [...new Set(sectionIds)], sections_url: window.location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
      added = true;
      const parse = value => new DOMParser().parseFromString(value, 'text/html');
      for (const [element, selector] of [[footer, '#main-cart-footer'], [items, '#main-cart-items']]) {
        if (!element) continue;
        const source = result.sections?.[element.dataset.id];
        const replacement = source && parse(source).querySelector(selector);
        if (!replacement) throw new Error('Cart refresh failed');
        element.innerHTML = replacement.innerHTML;
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && result.sections?.['cart-icon-bubble']) bubble.innerHTML = parse(result.sections['cart-icon-bubble']).querySelector('.shopify-section').innerHTML;
      if (drawer && result.sections?.['cart-drawer']) {
        if (inDrawer) { drawer.renderContents(result); }
        else {
          const source = parse(result.sections['cart-drawer']).querySelector('#CartDrawer');
          const target = drawer.querySelector('#CartDrawer');
          if (source && target) {
            target.innerHTML = source.innerHTML;
            drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
          }
        }
        drawer.classList.remove('is-empty');
      }
      await refreshOffers();
      announce(`${title} added to your cart.`);
      const focusTarget = inPopup && popup?.open ? popup.querySelector('.ra-upsell-dialog__close') : inDrawer ? document.getElementById('CartDrawer-Checkout') : document.getElementById('checkout');
      if (inDrawer && drawer) drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      setTimeout(() => focusTarget?.focus({ preventScroll: true }), 100);
      document.dispatchEvent(new CustomEvent('ra:upsell-added', { detail: { variantId, placement: inPopup ? 'popup' : inDrawer ? 'drawer' : 'page' } }));
    } catch (failure) {
      if (added) {
        // Never retry a successful add if section rendering failed: reload the cart instead.
        window.location.assign(`${root}cart`);
      } else { error.textContent = failure.message || 'Could not add this item. Please try again.'; }
    } finally {
      adding = false;
      if (select?.isConnected) select.disabled = false;
      if (button.isConnected) { button.disabled = false; button.textContent = label; }
    }
  });
})();
